// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/InstagramAccounts_SalvarTokenInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /instagram/accounts/salvar_token
 *
 * Updates the page access token for an Instagram account.
 */
import { registerContract } from './validate'

export interface InstagramAccounts_SalvarTokenInput {
instagram_account_id: number
page_access_token: string
}

registerContract('InstagramAccounts_SalvarTokenInput', {
  instagram_account_id: { type: 'number',  required: true },
  page_access_token:    { type: 'string',  required: true },
})
